import './bootstrap';
import 'bxslider/dist/jquery.bxslider';

// Externals
import '@wwdev/bootstrap/index.js';
import '@wwdev/functions/index.js';
import './wwdev/forms/index';
import '@fancyapps/fancybox';
import './wwdev/lazysizes/index.js';
import "@wwdev/product"
import './externals/hamburgers.js';

// Components
import'./components';


